import React, { useEffect, useState } from 'react'
import { getTrustees } from '../contentful'
import TitleBar from './TitleBar'
import marked from 'marked';
import { Helmet } from 'react-helmet';

const Trustees = () => {
  const [trustees, setTrustees] = useState([])




  useEffect(() => {
    getTrustees().then(data => setTrustees(data))
  }, [])




  return (
    <>
      <Helmet>
        <title>Lucille Graham Trust Board of Trustees</title>
        <meta
          name="description"
          content="The Lucille Graham Trust is entirely independent and the board of trustees continue to provide grants to music projects in London."
        />
        <link
          rel="canonical"
          href="https://www.lucillegrahamtrust.org.uk/trustees"
        />
      </Helmet>
      <TitleBar title="Trustees" />
      <div className="content text-center">
        <div className="trustees-wrapper">
          {trustees.map(trustee => {
            const text = marked(trustee.fields.content)

            return <div dangerouslySetInnerHTML={{ __html: text }} ></div>
          }
          )}

        </div>

      </div>
    </>
  )

}


export default Trustees;